// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vkuiPanel__in .publics {
  padding-left: 0px !important;
  padding-right: 0px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  padding-bottom: 2px !important;
  padding-top: 0px !important;
}

.testnew .vkuiGroup__separator {
  display: none !important;
}

.prePost .vkuiImageBase.vkuiGridAvatar {
  width: 100% !important;
  height: 40vh !important;
  border-radius: 10px 10px 0 0;
}

.channels {
  transition: all 0.7s;

  &.hidden {
    opacity: 0;
    height: 0px;
    transition: all 0.7s;
    visibility: hidden;
  }
}

.emptyWarning {
  padding-right: 10px;
  width: 20px !important;
  height: 20px !important;
}

.noFeeds {
  padding-top: 20vh;
}

.wrapperUI .adm-collapse {
  border-bottom: 1px solid;
  margin: 0;
  border-color: color-mix(in srgb,
      var(--vkui--color_separator_primary) 30%,
      transparent);
}

.wrapperUI .adm-collapse:last-of-type,
.wrapperUI .adm-list-item-content {
  border: none !important;
}

.wrapperUI .adm-list-item-content-main {
  padding: 0 !important;
}

.shareContent .vkuiButton svg {
  color: white !important;
}

.userCollapse {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-top: 2px;
}

.streams .vkuiHorizontalScroll__in-wrapper {
  align-items: center !important;
}

.hideme {
  display: none !important;
}

.prePost {
  background-color: var(--vkui--color_background_secondary);
  border-radius: 10px;
  padding: 0 !important;
}

.prePost .vkuiFormField__border,
.vkuiFocusVisible.vkuiFocusVisible {
  display: none;
}

.prePost .vkuiFormField {
  border: none !important;
}

html,
body,
#root,
#app {
  height: 100%;
  min-height: -webkit-fill-available;
  font-family: "Inter";
  background: var(--vkui--color_background_content) !important;
}

html {
  height: 100vh;
  height: 100dvh;
  overflow: auto !important;
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
}

html::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}

.tempButtons button {
  width: 12px;
  height: 26px;
  border: none;
  font-family: "Inter";
  font-weight: 700;
  color: var(--adm-color-text-secondary);
  background: none;
  font-size: 20px;
  padding: 0;
}

.adm-list-item-content-main {
  font-size: var(--vkui--font_headline1--font_size--regular);
}

.adm-collapse {
  background: var(--vkui--color_background_secondary);
  margin: 10px 0;
  padding: 10px !important;
  border-radius: 10px;
}

.adm-list-body {
  background: none !important;
  border: none !important;
}

.adm-list-item {
  background: none !important;
  padding-left: 0px !important;
}

.adm-list-item-content {
  padding-right: 0px !important;
}

.tempButtons button:hover {
  opacity: 0.8;
  cursor: pointer;
}

.vkuiSnackbar__body {
  text-align: left !important;
}

.days {
  display: flex;
  padding-top: 16px;
}

.days .vkuiCheckbox {
  display: flex;
  flex-direction: column;
}

.days .vkuiCheckbox__icon {
  margin-right: 0px;
}

.days .vkuiCheckbox__titleAfter {
  margin-left: 0px;
}

.daysTitle {
  margin-bottom: 12px;
}

/*.vkuiHeadline--level-1, .vkuiSubhead {*/
/*  color: #f5f5f5;*/
/*}*/

button.without_t {
  width: 90%;
  height: 50px;
  border-radius: 8px;
  border: none;
  background-color: #0965ba;
  font-family: "Inter";
  font-size: 17px;
  font-weight: bold;
  color: #fff;
  margin-top: 10%;
}

.onButton {
  height: 50px;
  border-radius: 8px;
  border: none;
  font-family: "Inter";
  font-size: 17px;
  font-weight: bold;
  transition: opacity 1s ease-in-out;
}

button.onButton:hover {
  cursor: pointer;
  opacity: 0.95;
  transition: opacity 1s ease-in-out;
}

.company_btn {
  width: 90%;
  height: 50px;
  border-radius: 8px;
  border: 1px #f5f5f5 solid;
  background: none;
  font-family: "Inter";
  font-size: 17px;
  font-weight: bold;
  color: #f5f5f5;
  margin-top: 10px;
}

.type-group {
  display: flex;
  align-items: center;
}

.type-group svg {
  width: 20px;
  height: 20px;
}

.howAdd .vkuiButton__content {
  font-size: 14px !important;
}

.company_buttons {
  display: flex;
  justify-content: space-between;
}

.styleElement .vkuiBanner__aside {
  display: none;
}

.postStyle {
  padding: 0 !important;
  margin-bottom: 30px;
}

.styleElement_post {
  display: none;
}

.terms-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  margin-top: 20px !important;
}

.terms_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  margin-top: 20px !important;
}

.terms_body {
  width: 100%;
}

.terms_body .vkuiGroup {
  padding: 0px !important;
}

.terms a {
  color: rgb(153, 162, 173);
}

.onSlider .vkuiBaseGallery__bullets {
  bottom: 0px;
}

.vkuiBaseGallery {
  max-width: 90vw;
  height: 70%;
}

button.without_t:hover,
button.company_btn:hover {
  cursor: pointer;
  opacity: 0.9;
}

.helpModal:hover {
  cursor: pointer;
  opacity: 0.6;
}

.inputTitle {
  display: flex;
  align-content: space-around;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.paidGroups {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 54vh;
}

.quantityPaidGroups {
  font-size: 48px;
  font-weight: 900;
}

.paidGroupsControlView span {
  font-size: 128px;
  font-weight: 700;
  padding: 0px 40px 0px 40px;
}

.quantityGroups {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.groupsControls {
  display: flex;
  justify-content: center;
  align-items: center;
}

.quantityGroups span {
  font-size: 128px;
  font-weight: 700;
  padding: 0px 40px 40px 40px;
}

.changeGroupsPaid {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 85vh;
}

.quantityGroups button,
.paidGroupsControlView button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 100%;
  font-size: 18px;
}

.groupsAfter {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  text-align: center;
}

.gptDriveView {
  padding: 20px;
}

.settingsGroups .vkuiGroup {
  padding: 0 !important;
}

.save_group {
  display: none;
  visibility: hidden;
}

.vkuiGroup .viewControl {
  padding: 0 !important;
  width: 50%;
}

.viewControl .vkuiDiv {
  padding: 0 !important;
}

.viewControl .vkuiSegmentedControl {
  width: 70%;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Inter", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: auto;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

:not(.vkuiModalRoot--desktop).vkuiModalRoot--hasCustomPanelHeaderAfterSlot .vkuiModalRoot__viewport {
  top: 0px !important;
}

.vkuiSnackbar {
  left: 0 !important;
}

.vkuiModalPage__in {
  height: 90% !important;
}

.inputRoot .vkuiModalPage__in-wrap {
  z-index: 11;
}

.inputRoot .vkuiModalRoot__mask {
  z-index: 10;
}

.inputBody .vkuiModalPage__in-wrap {
  z-index: 11;
}

.inputBody .vkuiModalRoot__mask {
  z-index: 10;
}

.sign-editor {
  color: var(--vkui--color_text_primary);
  padding: 10px;
  overflow-y: auto;
  min-height: 8vh;
  max-height: 60vh;
  font-size: initial;
  flex: 1 1;
  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_placeholder_alpha);
  border-radius: inherit;
}

.sign-editor:focus,
.urlInput:focus {
  outline: none;
}

.sign-editor.empty::before {
  content: attr(data-placeholder);
  color: #76787a;
  pointer-events: none;
}

.signSection .sign-buttons {
  padding: 10px;
  gap: 8px;
}

.urlInput {
  width: 100%;
  height: 40px;
  border-radius: 12px;
  border: none;
  padding-left: 8px;
  font-family: "Inter";
  background: var(--tgui--tertiary_bg_color);
  box-shadow: 0 0 0 1px var(--tgui--outline);
  color: var(--tg-theme-text-color);
}

.format-button.sign-button.button-delete {
  background-color: #e64646 !important;
}

.format-button.sign-button.button-delete svg path {
  fill: #f5f5f5;
}

.signSection .sign-button {
  background-color: var(--tgui--tertiary_bg_color) !important;
  box-shadow: 0 0 0 1px var(--tgui--outline) !important;
}

.signEditor {
  padding: 10px;
  overflow-y: auto;
  min-height: 8vh;
  max-height: 60vh;
  font-size: initial;
  flex: 1 1;
  border-radius: inherit;
}

.signEditor:focus {
  outline: none;
}

.signEditor.empty::before {
  content: attr(data-placeholder);
  color: #76787a;
  pointer-events: none;
}

.img-tag {
  width: 16px;
  border-radius: 100%;
  margin-right: 8px;
}

.tg_tag {
  background: #24a1de24 !important;
}

.vk_tag {
  background: #0077ff24 !important;
}

.source-tag {
  font-size: 13px !important;
  padding: 0 8px !important;
}

.sources-input {
  font-size: 13px !important;
}

.sign-button {
  background-color: var(--vkui--color_background--active) !important;
  color: var(--vkui--color_background_modal_inverse);
  width: 40px !important;
  height: auto !important;
  aspect-ratio: 1 / 1 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.sign-button.active {
  background-color: #2688eb !important;
  border: none;
  color: #ffffff;
}

.sign-buttons {
  display: flex;
  padding-bottom: 10px;
  gap: 4px;
}

.saveButtonWrapper {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  right: 0;
  padding: 10px 20px;
  box-sizing: border-box;
  background: var(--vkui--color_background_content);
}

.inputBody .vkuiFormItem--withPadding,
.inputRoot .vkuiFormItem--withPadding {
  background: var(--vkui--color_background_secondary);
  margin: 10px 0;
  padding: 10px !important;
  border-radius: 10px;
}

.headerSettings .communityButton {
  flex: 3 1;
}

.communityButton .vkuiButton__content {
  margin: 0 !important;
  padding: 0 !important;
  font-size: var(--vkui--font_headline1--font_size--regular) !important;
}

.communityButton .vkuiButton__in {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 70px;
}

.communityButton .vkuiButton__before {
  display: flex;
  padding: 0 !important;
}

.modal_choose_full,
.vkuiModalRoot__mask {
  z-index: 10;
}

.modal_choose_full,
.modal_choose {
  z-index: 10;
}

.modal_choose {
  align-items: flex-start !important;
  padding-top: 50% !important;
}

#loginVK {
  width: 90%;
  padding-top: 24px;
}

.onboarding {
  flex-direction: column;
  align-items: center;
  height: 100vh;
  padding: 0 20px;
  justify-content: space-evenly;
}

div#Accordion\\:r7\\: {
  border-radius: 12px !important;
}

.ModalChannels>div {
  overflow: auto;
  scrollbar-width: none;
}

span.tgui-c8f4bcd1606fb026.tgui-562f7459d74103ea.tgui-6e63faaa2b33f4ae {
  background: #2688eb !important;
}

.addChannel svg {
  color: #fff !important;
}

label.tgui-b5d680db78c4cc2e.tgui-34eb6f8b96874d40.tgui-b8dfba0b5c3d054c.tgui-7b5bccbb645b495f:hover {
  opacity: 1 !important;
}

.copyLink h6,
.copyLink svg {
  color: #2688eb !important;
  font-family: Inter;
  font-weight: normal;
}

.sectionChannelRss hr {
  display: none;
}

.deleteRss {
  background: var(--vkui--color_background_negative) !important;
}

.deleteRss svg {
  color: #fff !important;
}

.rssItems {
  display: flex;
  flex-direction: column;
}

.overlaySpinner {
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: #000000e3;
  z-index: 1;
  left: 0px;
  top: 0px;
}

.overlaySpinnerFirst {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: #000000e3;
  z-index: 1;
  left: 0px;
  top: 0px;
}

.overlaySpinner span {
  font-size: medium;
}

.onSlide svg {
  width: 60%;
}

.onSlide {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/*.lottie {*/
/*  padding-bottom: 20px;*/
/*}*/

.VKID #loginVK {
  width: 100%;
}

.VKID {
  color: #969696;
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 70vh;
  justify-content: space-between;
}

.VKlogin #loginVK {
  width: 95%;
}

.loader-hidden {
  visibility: hidden;
}

.loader-visible {
  visibility: visible;
}

.post_counter span {
  font-weight: 700;
}

.post_counter,
.post_counter p {
  font-size: 14px;
  font-weight: 500;
}

.post_counter p,
.post_counter span {
  padding: 0 10px;
}

.switchAuto {
  margin: 10px 0;
}

.premodelist .vkuiSimpleCell {
  padding: 6px 10px;
  background: var(--vkui--color_background_secondary);
  border-radius: 6px;
}

.switchAuto .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:after {
  background: #4bb34b;
}

.switchPremode .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:after {
  background: #8109b9;
}

.MuiSvgIcon-root {
  color: var(--vkui--color_text_primary);
}

.MuiIconButton-root:hover {
  background-color: var(--vkui--color_field_background) !important;
}

.lottie.saveOpt svg {
  width: 60% !important;
}

.premodePanel .vkuiPanel__in {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.generatePostButton .vkuiButton__content {
  font-family: "Inter" !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}

.generatePostButton {
  color: white;
  font-weight: 600;
  font-size: 14px;
  margin: 30px 12px;
  padding: 14px 20px 14px 20px;
  border-radius: 0.7em;
  background: -webkit-linear-gradient(225deg,
      rgb(251, 175, 21),
      rgb(251, 21, 242),
      rgb(21, 198, 251)) 0% 0% / 300% 300%;
  background-size: 200% auto;
  animation: gradient_move 3s ease infinite;
  border: none;
  font-family: "Inter";
  transition: all 0.2s ease-in-out;
  -webkit-transition: all 0.2s ease-in-out;
}

.gptText {
  color: var(--vkui--color_text_primary);
  padding: 10px;
  font-size: initial;
  white-space: pre-wrap;
}

.gptText p {
  text-align: left;
  font-size: initial;
  margin: 0;
}

.adm-auto-center-content {
  white-space: pre-wrap;
}

.inputTitleFirst {
  display: flex;
}

.adm-center-popup-wrap {
  min-width: 90vw !important;
}

.adm-center-popup-mask {
  background: rgba(0, 0, 0, 0.8) !important;
}

.adm-modal-body {
  font-size: var(--adm-font-size-8);
  font-family: "Inter";
}

.adm-space.adm-space-block.adm-space-vertical.adm-modal-footer {
  display: none;
}

.vkBadge {
  background-color: var(--vkui--color_icon_accent);
  color: var(--tg-theme-button-text-color);
  font-family: "Inter";
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-radius: 10px;
  padding: 1px;
  font-weight: bold;
  min-width: 56px;
  margin-left: 10px;
}

.generatePostButton:hover {
  transition: all 0.2s ease-in-out;
  -webkit-transition: all 0.2s ease-in-out;
  cursor: pointer;
  color: rgba(255, 255, 255, 1);
  box-shadow: 0 5px 15px rgba(145, 92, 182, 0.4);
}

@keyframes gradient_move {
  0% {
    background-position: 0% 92%;
  }

  50% {
    background-position: 100% 9%;
  }

  100% {
    background-position: 0% 92%;
  }
}

.premodelist .vkuiVisuallyHidden,
.post-page .vkuiVisuallyHidden {
  opacity: 1;
  width: auto !important;
  height: auto !important;
  clip-path: none !important;
  clip: auto !important;
  position: inherit !important;
  padding-top: 20px !important;
}

.premodelist .vkuiSpinner,
.post-page .vkuiSpinner {
  flex-direction: column;
}

.introFeaturesItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  flex: 1 1;
}

.premodelist {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.saveOpt div {
  display: flex;
  justify-content: center;
  padding-bottom: 10%;
  padding-top: 10%;
}

.PicPopover {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.post_counter {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: none;
  padding: 0 10px;
}

.VKlogin {
  color: #969696;
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 40vh;
  justify-content: space-between;
  align-items: center;
  padding-top: 20% !important;
}

.welcomeHeadline {
  font-size: var(--vkui--font_headline2--line_height--compact) !important;
  padding-bottom: 10px !important;
  padding-top: 18px !important;
}

.welcomeDesc {
  padding-bottom: 30px !important;
}

.gtpPrompt textarea {
  height: 100px;
  font-family: "Inter";
}

.groupInput .react-tagsinput {
  background-color: #fff;
  border: 1px solid #ccc;
  padding-left: 5px;
  padding-top: 5px;
  background-color: var(--vkui--color_field_background);
  border-radius: var(--vkui--size_border_radius--regular);
  border-color: var(--vkui--color_write_bar_input_border);
  border-color: var(--vkui--color_field_border_alpha);
  display: flex;
  flex-direction: row;
  width: auto;
  flex-wrap: wrap;
}

.groupInput .react-tagsinput-input {
  color: var(--vkui--color_text_primary);
  font-family: "Inter";
  font-size: var(--vkui--font_paragraph--font_size--regular);
  width: 200px;
}

.groupInput .react-tagsinput--focused {
  border-color: var(--vkui--color_stroke_accent);
}

.AppBottom {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: stretch;
  padding-top: 10px;
}

.groupInput .react-tagsinput-tag {
  font-family: "Inter";
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 5px;
  margin-right: 2px;
  color: var(--vkui--color_text_primary);
  background: var(--vkui--color_header_background);
  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_border_alpha);
  border-radius: 6px;
  font-size: var(--vkui--font_paragraph--font_size--regular);
  display: inline-flex;
  position: relative;
  align-items: center;
  padding: 0 12px;
}

.groupInput .react-tagsinput-remove {
  cursor: pointer;
  font-weight: 400;
  font-size: 26px;
  color: var(--vkui--color_icon_secondary);
  padding-left: 4px;
  padding-bottom: 4px;
}

.premodelistItem {
  padding: 0 !important;
  gap: 6px;
  display: flex;
  flex-direction: column;
}

.vkuiGroup.premodelist {
  padding: 16px 16px !important;
}

.quill p {
  text-align: left;
  color: var(--tgui--text_color);
  font-size: var(--tgui--text--font_size);
}

.applyLink {
  flex: 1 1;
  background: #2688eb;
  border: none;
  color: var(--tg-theme-button-text-color);
  margin: 6px 10px;
  height: 32px;
  border-radius: 6px;
  font-family: Inter;
  transition: all 0.3s;
}

.applyLink:hover {
  transition: all 0.3s;
  opacity: 0.8;
}

.wrapperUI {
  padding: var(--tg-content-safe-area-inset-top) 20px 10px 20px !important;
}

.onboardingUI {
  height: 90vh;
}

.vkuiGroup .vkuiFormItem--withPadding {
  padding: 10px 0 10px 0;
}

.vkuiSeparator {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.userGroups .vkuiBanner__aside {
  display: none;
}

.groupItem .vkuiBanner__in,
.vkuiBanner__in:before {
  padding: 6px !important;
  background-color: #ffffff00 !important;
  border: none !important;
}

.userGroups .groupItem .vkuiBanner__in,
.vkuiBanner__in:before {
  padding: 12px !important;
  background-color: #ffffff00 !important;
  border: none !important;
}

.userGroups .groupItem .vkuiBanner__in {
  flex-direction: column;
  align-items: center;
}

.userGroups .groupItem .vkuiBanner__in .vkuiBanner__before {
  margin: 0;
  padding-bottom: 10px;
}

.userGroups .groupItem .vkuiBanner__in .vkuiBanner__content p {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 36vw;
}

.groupsFooter {
  margin: 0 !important;
}

.groupItem,
.groupEdit {
  padding: 0 !important;
}

.gmpMode {
  margin: 0 !important;
}

.titleItem,
.channelTitle {
  padding: 0 !important;
}

.communityButton {
  background: var(--vkui--color_background_secondary) !important;
  color: var(--tg-theme-text-color) !important;
}

.communityButton:hover {
  opacity: 0.8;
}

.postingOn {
  background: var(--vkui--color_text_positive) !important;
  color: var(--vkui--color_background_contrast) !important;
}

.postingOff {
  background: var(--vkui--color_text_negative) !important;
  color: var(--vkui--color_background_contrast) !important;
}

.headerButtonWrapper {
  display: flex;
  flex-direction: column;
  line-height: normal;
}

.headerButtonTitle {
  font-size: var(--vkui--font_footnote--font_size--regular);
  color: var(--vkui--color_background_contrast);
}

.headerSubButtonTitle {
  font-size: var(--vkui--font_footnote--font_size--regular);
  color: var(--tg-theme-text-color);
  display: flex;
  align-items: center;
}

.headerSubButtonTitle span {
  margin-left: 4px;
}

.headerButtonDesc {
  font-size: var(--vkui--font_caption2--font_size--regular);
  color: var(--vkui--color_background_contrast);
  font-weight: 400;
  opacity: 0.8;
}

.headerSettings {
  display: flex;
  padding-top: 12px;
  box-sizing: border-box;
}

.headerFirst .communityButton {
  margin-left: 6px;
  width: 25% !important;
}

.headerSettings .communityButton:first-of-type {
  margin-right: 6px;
}

.headerSettings .communityButton:last-of-type {
  margin-left: 6px;
}

.channelTitle {
  margin: 0 !important;
  width: 75% !important;
}

.channelTitle .vkuiBanner__content p {
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.groupItem p {
  text-align: left;
}

.groupImage {
  border-radius: 100px !important;
}

/* .vkuiBaseGallery__bullets {
  position: inherit!important;
  padding-top: 25px!important;
} */

.payGroupsFooter {
  text-align: center;
}

.payMethod .adm-selector-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border-radius: var(--vkui--size_border_radius--regular);
  aspect-ratio: 2 / 1;
  justify-content: center;
}

.postsSelect .adm-selector-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border-radius: var(--vkui--size_border_radius--regular);
  aspect-ratio: 1 / 1;
  justify-content: center;
}

.groupsPaid {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 90vh;
}

.availableSlot {
  font-size: small;
  opacity: 50%;
  padding-left: 10px;
}

.square,
.list {
  color: #f5f5f5;
}

.square:hover,
.list:hover {
  opacity: 80%;
  cursor: pointer;
}

.list {
  opacity: 30%;
}

.channelsSegmented {
  width: 30%;
}

.addChannel {
  background: #007aff !important;
}

.addChannel:hover {
  color: var(--vkui--color_background--hover);
  background-color: #007bffa4 !important;
}

.no_data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70vh;
}

.onboardingContainter {
  display: flex;
  min-height: 95vh;
  flex-direction: column;
  justify-content: center;
}

.hide-hr hr {
  display: none;
}

.OnboardingButtonContainer {
  width: 100%;
}

.addSource {
  background: #2688eb !important;
  color: #fff !important;
  max-width: 40px;
  max-height: 40px;
}

.addSource:hover {
  opacity: 0.7;
}

.addSource svg {
  color: #fff !important;
}

.fadeSlide {
  height: 10px !important;
}

.welcome_no {
  display: flex;
  justify-content: center;
  text-align: center;
}

/* .sectionChannelTimersList span {
  color: var(--vkui--color_text_secondary);
} */

.sectionChannelTimersList .vkuiButton__content {
  color: white;
}

.timerChip h6 {
  color: var(--vkui--color_text_primary) !important;
}

.first-name {
  font-size: 20px;
}

.postheader {
  padding-top: 16px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 10px 0 0 0;
  gap: 10px;
}

.hideInactiveBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  transition: all 0.2s ease;
  color: var(--vkui--color_icon_secondary);
  flex-shrink: 0;
}

.hideInactiveBtn:hover {
  background: var(--vkui--color_background_secondary) !important;
  opacity: 1 !important;
  color: var(--vkui--color_icon_primary);
}

.hideInactiveBtn:active {
  transform: scale(0.92);
  opacity: 0.85 !important;
}

.divider {
  height: 1px;
  background-color: var(--vkui--color_separator_primary);
  background-clip: content-box, padding-box;
}

.HeaderBar {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 10px;
  background: var(--vkui--color_background_secondary);
  border-radius: var(--vkui--size_border_radius--regular);
}

.topHeader,
.bottomHeader {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
}

img.pic {
  width: 42px;
  border-radius: 100%;
}

.PostsCount {
  background: #007aff;
  padding: 0 6px 0 6px;
  border-radius: 100px;
  color: white;
}

/*.payform-tinkoff-btn {*/
/*  display: none;*/
/*}*/

.paymentTink {
  display: none;
}

.payform-tinkoff-btn:hover {
  cursor: pointer;
  opacity: 0.9;
}

.payform-tinkoff-btn:active {
  cursor: pointer;
  opacity: 0.8;
}

.paymentBtn:hover {
  cursor: pointer;
  opacity: 0.9;
}

.paymentBtn:active {
  cursor: pointer;
  opacity: 0.8;
}

.user_info {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding-left: 12px;
}

.posts_info {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.posts_info .posts_header_text,
.posts_info .first-name {
  margin: 0;
}

.company_info {
  display: flex;
  align-items: center;
}

.user_info p {
  text-align: start;
  margin: 0;
}

.user_info .first-name {
  font-weight: 500;
}

.welcome,
.posts_header_text {
  font-size: 14px;
}

header button {
  width: 34%;
  margin: 5%;
  background-color: var(--tg-theme-secondary-bg-color);
  border: none;
  color: var(--tg-theme-text-color);
  height: 38px;
  border-radius: 38px;
  font-family: "Inter";
  font-weight: 500;
}

header button:hover,
img:hover {
  background-color: color-mix(in srgb,
      var(--tg-theme-secondary-bg-color) 90%,
      transparent);
  opacity: 90%;
  cursor: pointer;
}

/* p {
  text-align: center;
  color: var(--tg-theme-text-color);
  font-size: x-large;
} */

#content {
  display: flex;
  flex-direction: column;
  align-items: center;
  /*padding-bottom: 6vh;*/
}

.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-container svg {
  height: auto;
  width: 75%;
  padding-top: 10%;
  padding-bottom: 10%;
}

.modal_choose .vkuiCardGrid {
  width: 100%;
}

.modal_choose .vkuiBanner__in {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}

.modal_choose .vkuiBanner__aside {
  display: none;
}

.modal_choose .vkuiBanner__before {
  margin: 10px;
}

.modeContainer {
  display: flex !important;
  padding: 20px 4px;
  justify-content: space-between;
}

.modeContainer .adm-space-item {
  margin: 0 !important;
}

.modeContainer .adm-radio-content {
  font-family: var(--vkui--font_text--font_family--regular);
  font-size: var(--vkui--font_text--font_size--regular);
}

.userGroups .vkuiCard {
  margin: 0px !important;
}

.userGroups .vkuiCardGrid {
  gap: 8px !important;
}

.listView .vkuiCardGrid {
  display: flex !important;
  flex-direction: column !important;
  flex-wrap: nowrap !important;
  gap: 6px !important;
}

.listView .vkuiCard {
  display: flex !important;
  width: 100% !important;
  margin: 0px !important;
}

.listView .groupItem {
  display: flex !important;
  flex-direction: row !important;
  width: 100% !important;
}

.listView .vkuiBanner__in {
  display: flex !important;
  width: 100% !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
}

.listView .vkuiBanner__before {
  padding: 0px !important;
}

.listView .vkuiBanner__content {
  display: flex !important;
  align-items: flex-start !important;
  padding-left: 14px !important;
}

.listView .vkuiBanner__content p {
  max-width: 100% !important;
}

.listView .vkuiBanner__aside {
  display: flex !important;
}

span,
div,
a,
p {
  font-family: "Inter" !important;
}

div[vaul-snap-points-overlay="true"] {
  background: rgb(0 0 0 / 60%) !important;
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}

.channelAddItem {
  background-color: var(--vkui--color_background_secondary);
}

.soonItem {
  opacity: 0.6;
}

.ModalChannels header h1,
.ModalChannels footer span {
  color: var(--vkui--color_text_secondary);
}

.ModalChannels>div>div>section>div>div {
  background: none !important;
}

.adm-picker-view-column:before {
  display: flex;
  width: 100%;
  justify-content: center;
  padding-top: 50px;
}

.adm-picker-view-column:nth-of-type(1):before {
  content: "Часы";
}

.adm-picker-view-column:nth-of-type(3):before {
  content: "Минуты";
}

.adm-picker-view-column:nth-of-type(1) .adm-picker-view-column-item {
  justify-content: flex-end;
  width: 100%;
}

.adm-picker-view-column:nth-of-type(3) .adm-picker-view-column-item {
  justify-content: flex-start;
  width: 100%;
}

#paysuccess .vkuiPanel__in.vkuiInternalPanel__in {
  display: flex;
  justify-content: center;
}

.channelTitleTest {
  margin: 0;
  padding: 0;
  width: 100%;
}

.sourceFavicon {
  background: none !important;
  box-shadow: none !important;
}

.fullURL>div {
  background: color-mix(in srgb,
      var(--adm-color-primary) 15%,
      transparent) !important;
  border-left: 3px solid var(--adm-color-primary) !important;
  padding: 6px 28px 8px 12px !important;
  margin: 10px 20px !important;
}

.fullURL svg {
  display: none;
}

.TestDriveCell h6 {
  color: var(--vkui--color_text_secondary);
}

.sectionChannel>div>div>div,
.sectionChannelMode>div>div>label,
.sectionChannelModeNotice,
.sectionChannelModeNotice select,
.sectionChannel label,
.sectionChannelStreams>div>div>div>label,
.sectionChannelSources>div>div>div>label,
.sectionChannelOther div>label {
  background: var(--vkui--color_background_secondary) !important;
}

.sectionChannel h1,
.sectionChannel h6,
.sectionChannelStyle>footer span,
.sectionChannelMode h1,
.sectionChannelMode label>div>span:nth-child(2),
.sectionChannelStreams h1,
.sectionChannelSources h1,
.sectionChannelStreams>div>div>div>div h6,
.sectionChannelStreams>footer span,
.sectionChannelSources>div>div>div>div h6,
.sectionChannelSources>footer span,
.sectionChannelOther h1,
.sectionChannelOther h6,
.sectionChannelTimers h1,
.sectionChannelStyle h1 {
  color: var(--vkui--color_text_secondary);
  white-space: break-spaces;
}

.sectionChannel svg,
.settingsItem>div>div>span,
.sectionChannelStyle svg,
.settingsItem>div>div>span {
  color: var(--vkui--color_text_secondary);
  display: flex;
  align-items: flex-end;
}

.sectionChannel>div>div,
.sectionChannelMode>div>div,
.sectionChannelOther>div>div,
.sectionChannelOther>div>div {
  background: none !important;
}

.sectionChannelStreams>div>div,
.sectionChannelSources>div>div,
.sectionChannelTimers>div>div,
.sectionChannelTimers select,
.sectionChannelStyle>div>div {
  background: var(--vkui--color_background_secondary) !important;
}

.sectionChannelSources>div>div svg {
  color: var(--vkui--color_text_secondary);
}

.sectionChannelStreams>div>div>button svg {
  color: #2688eb;
}

.postsItem>div:nth-child(3) span>span {
  background: #2688eb;
}

.tgui-1ec4b447aa5cf66a,
.tgui-8d2d5ba97b4abd79 {
  color: #2688eb !important;
}

.tgui-f23c0e195677169c {
  background: none !important;
}

.socialBadge {
  position: absolute;
  max-width: 16px;
  bottom: 16px;
  left: 16px;
  height: auto;
  border-radius: 100px;
  border: 2px solid var(--vkui--color_background_secondary);
}

@keyframes fade_sources {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }
}

.sectionPrompts svg {
  display: none;
}

.tgui-64a5a0dc5509605e {
  overflow-wrap: normal !important;
}

.tgui-97f2df57786b02dc:not(.tgui-ecf101b3117a96c8):after {
  animation: fade_sources 2s linear infinite !important;
  background-color: var(--vkui--color_background_modal) !important;
  border-radius: 6px;
}

.tgui-97f2df57786b02dc:before {
  background: var(--vkui--color_background_modal--active) !important;
  border-radius: 6px;
}

.SettingsItemIcon {
  width: 28px;
  height: 28px;
}

.tempStyle .tgui-4de4feff2dcc975c,
.tempStyle .tgui-2b0a006b5a9ffd68 {
  background: #2688eb !important;
}

.deleteStream,
.deleteSource {
  background: color-mix(in srgb, #ff0000 15%, transparent) !important;
  color: #ff2929 !important;
}

.deleteSource h6,
.deleteSource svg {
  color: #ff2929 !important;
}

.addSource {
  background: #2688eb !important;
  max-width: 40px;
  max-height: 40px;
}

.sectionSourceDone .tgui-8af0d10d5540c6cc:last-of-type {
  display: none;
}

.addSource svg {
  color: #fff !important;
}

.streamsIcon svg {
  color: var(--vkui--color_icon_accent_themed);
}

.adm-swiper-slide {
  transform: scale(0.95);
  transition: all 0.3s;
}

.adm-swiper-slide-active {
  transform: scale(1) !important;
}

.adm-page-indicator {
  --dot-color: var(--adm-color-light);
  --active-dot-color: var(--adm-color-primary);
  --dot-size: 8px !important;
  --active-dot-size: 8px !important;
  --dot-border-radius: 10px !important;
  --dot-spacing: 4px !important;
}

.channelAvatar {
  box-shadow: none !important;
}

.postingSwitch input:checked+.tgui-3acc6d0262399734:before {
  background: #4bb34b !important;
}

.postingSwitch>div:before {
  background: #0f0f0f !important;
}

.timersList {
  padding: 10px 0 !important;
}

.timersList>div>div {
  width: 24vw;
  background: var(--vkui--color_background--hover);
}

.onboardingWrapper {
  display: flex;
  height: 100vh;
  justify-content: space-evenly;
  flex-direction: column;
}

.onboardingButtonGroups {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.onboardingButtonSet {
  background: #2990ff !important;
}

.onboardingButtonSetSecond {
  background: #2990ff26 !important;
}

.onboardingButtonLater {
  color: #2990ff !important;
}

.sectionOnboardingItems {
  flex-direction: column;
  padding: 12px !important;
  background: var(--vkui--color_background_secondary) !important;
}

.sectionOnboardingItems>div:nth-child(2) {
  align-items: center;
  padding: 0;
}

.sectionOnboardingItems h6 {
  color: var(--vkui--color_text_secondary);
}

.tgui-bca5056bf34297b0 {
  color: #2688eb !important;
}

:disabled {
  cursor: not-allowed;
  opacity: 0.35;
}

.tgui-e11a455378c63b15,
.tgui-b632646f586ff14d {
  background-color: var(--vkui--color_icon_tertiary--hover) !important;
}

.saveLoader {
  color: var(--vkui--color_icon_secondary--hover) !important;
  position: fixed !important;
  right: 4vh;
  bottom: 4vh;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;;EAEpB;IACE,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT;;kBAEgB;AAClB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yDAAyD;EACzD,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,YAAY;EACZ,kCAAkC;EAClC,oBAAoB;EACpB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,mDAAmD;EACnD,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC,oBAAoB;AACpB,IAAI;;AAEJ;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE;aACW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,0FAA0F;EAC1F,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,0CAA0C;EAC1C,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2DAA2D;EAC3D,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kEAAkE;EAClE,kDAAkD;EAClD,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;;EAEE,mDAAmD;EACnD,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,YAAY;AACZ,0BAA0B;AAC1B,IAAI;;AAEJ;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;EACpB;;;0CAGwC;EACxC,0BAA0B;EAC1B,yCAAyC;EACzC,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,eAAe;EACf,6BAA6B;EAC7B,8CAA8C;AAChD;;AAgBA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uEAAuE;EACvE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,qDAAqD;EACrD,uDAAuD;EACvD,uDAAuD;EACvD,mDAAmD;EACnD,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,0DAA0D;EAC1D,YAAY;AACd;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,gDAAgD;EAChD,qFAAqF;EACrF,kBAAkB;EAClB,0DAA0D;EAC1D,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,uBAAuB;EACvB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;EACxB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,8DAA8D;EAC9D,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uDAAuD;EACvD,wDAAwD;AAC1D;;AAEA;EACE,uDAAuD;EACvD,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,6CAA6C;AAC/C;;AAEA;EACE,yDAAyD;EACzD,iCAAiC;EACjC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;EACzD,6CAA6C;EAC7C,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;GAGG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uDAAuD;EACvD,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uDAAuD;EACvD,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,8DAA8D;EAC9D,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,sDAAsD;EACtD,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mDAAmD;EACnD,uDAAuD;AACzD;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;AACd;;AAEA,yBAAyB;AACzB,mBAAmB;AACnB,IAAI;;AAEJ;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,oDAAoD;EACpD,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE;;kBAEgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;GAIG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yDAAyD;EACzD,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE;;6BAE2B;EAC3B,0DAA0D;EAC1D,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;;;;;;EAQE,8DAA8D;AAChE;;AAEA;;;;;;;;;;;;;;;EAeE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;;;EAIE,wCAAwC;EACxC,aAAa;EACb,qBAAqB;AACvB;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,8DAA8D;AAChE;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;EACrD,gEAAgE;EAChE,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;EAClE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,mEAAmE;EACnE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,0BAA0B;EAC1B,iCAAiC;EACjC,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,8DAA8D;AAChE;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,oEAAoE;AACtE;;AAEA;EACE,0DAA0D;EAC1D,0BAA0B;EAC1B,UAAU;EACV,WAAW;AACb","sourcesContent":[".vkuiPanel__in .publics {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  padding-bottom: 2px !important;\n  padding-top: 0px !important;\n}\n\n.testnew .vkuiGroup__separator {\n  display: none !important;\n}\n\n.prePost .vkuiImageBase.vkuiGridAvatar {\n  width: 100% !important;\n  height: 40vh !important;\n  border-radius: 10px 10px 0 0;\n}\n\n.channels {\n  transition: all 0.7s;\n\n  &.hidden {\n    opacity: 0;\n    height: 0px;\n    transition: all 0.7s;\n    visibility: hidden;\n  }\n}\n\n.emptyWarning {\n  padding-right: 10px;\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.noFeeds {\n  padding-top: 20vh;\n}\n\n.wrapperUI .adm-collapse {\n  border-bottom: 1px solid;\n  margin: 0;\n  border-color: color-mix(in srgb,\n      var(--vkui--color_separator_primary) 30%,\n      transparent);\n}\n\n.wrapperUI .adm-collapse:last-of-type,\n.wrapperUI .adm-list-item-content {\n  border: none !important;\n}\n\n.wrapperUI .adm-list-item-content-main {\n  padding: 0 !important;\n}\n\n.shareContent .vkuiButton svg {\n  color: white !important;\n}\n\n.userCollapse {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-top: 2px;\n}\n\n.streams .vkuiHorizontalScroll__in-wrapper {\n  align-items: center !important;\n}\n\n.hideme {\n  display: none !important;\n}\n\n.prePost {\n  background-color: var(--vkui--color_background_secondary);\n  border-radius: 10px;\n  padding: 0 !important;\n}\n\n.prePost .vkuiFormField__border,\n.vkuiFocusVisible.vkuiFocusVisible {\n  display: none;\n}\n\n.prePost .vkuiFormField {\n  border: none !important;\n}\n\nhtml,\nbody,\n#root,\n#app {\n  height: 100%;\n  min-height: -webkit-fill-available;\n  font-family: \"Inter\";\n  background: var(--vkui--color_background_content) !important;\n}\n\nhtml {\n  height: 100vh;\n  height: 100dvh;\n  overflow: auto !important;\n  -ms-overflow-style: none !important;\n  scrollbar-width: none !important;\n}\n\nhtml::-webkit-scrollbar {\n  width: 0 !important;\n  height: 0 !important;\n}\n\n.tempButtons button {\n  width: 12px;\n  height: 26px;\n  border: none;\n  font-family: \"Inter\";\n  font-weight: 700;\n  color: var(--adm-color-text-secondary);\n  background: none;\n  font-size: 20px;\n  padding: 0;\n}\n\n.adm-list-item-content-main {\n  font-size: var(--vkui--font_headline1--font_size--regular);\n}\n\n.adm-collapse {\n  background: var(--vkui--color_background_secondary);\n  margin: 10px 0;\n  padding: 10px !important;\n  border-radius: 10px;\n}\n\n.adm-list-body {\n  background: none !important;\n  border: none !important;\n}\n\n.adm-list-item {\n  background: none !important;\n  padding-left: 0px !important;\n}\n\n.adm-list-item-content {\n  padding-right: 0px !important;\n}\n\n.tempButtons button:hover {\n  opacity: 0.8;\n  cursor: pointer;\n}\n\n.vkuiSnackbar__body {\n  text-align: left !important;\n}\n\n.days {\n  display: flex;\n  padding-top: 16px;\n}\n\n.days .vkuiCheckbox {\n  display: flex;\n  flex-direction: column;\n}\n\n.days .vkuiCheckbox__icon {\n  margin-right: 0px;\n}\n\n.days .vkuiCheckbox__titleAfter {\n  margin-left: 0px;\n}\n\n.daysTitle {\n  margin-bottom: 12px;\n}\n\n/*.vkuiHeadline--level-1, .vkuiSubhead {*/\n/*  color: #f5f5f5;*/\n/*}*/\n\nbutton.without_t {\n  width: 90%;\n  height: 50px;\n  border-radius: 8px;\n  border: none;\n  background-color: #0965ba;\n  font-family: \"Inter\";\n  font-size: 17px;\n  font-weight: bold;\n  color: #fff;\n  margin-top: 10%;\n}\n\n.onButton {\n  height: 50px;\n  border-radius: 8px;\n  border: none;\n  font-family: \"Inter\";\n  font-size: 17px;\n  font-weight: bold;\n  transition: opacity 1s ease-in-out;\n}\n\nbutton.onButton:hover {\n  cursor: pointer;\n  opacity: 0.95;\n  transition: opacity 1s ease-in-out;\n}\n\n.company_btn {\n  width: 90%;\n  height: 50px;\n  border-radius: 8px;\n  border: 1px #f5f5f5 solid;\n  background: none;\n  font-family: \"Inter\";\n  font-size: 17px;\n  font-weight: bold;\n  color: #f5f5f5;\n  margin-top: 10px;\n}\n\n.type-group {\n  display: flex;\n  align-items: center;\n}\n\n.type-group svg {\n  width: 20px;\n  height: 20px;\n}\n\n.howAdd .vkuiButton__content {\n  font-size: 14px !important;\n}\n\n.company_buttons {\n  display: flex;\n  justify-content: space-between;\n}\n\n.styleElement .vkuiBanner__aside {\n  display: none;\n}\n\n.postStyle {\n  padding: 0 !important;\n  margin-bottom: 30px;\n}\n\n.styleElement_post {\n  display: none;\n}\n\n.terms-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  margin-top: 20px !important;\n}\n\n.terms_container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  margin-top: 20px !important;\n}\n\n.terms_body {\n  width: 100%;\n}\n\n.terms_body .vkuiGroup {\n  padding: 0px !important;\n}\n\n.terms a {\n  color: rgb(153, 162, 173);\n}\n\n.onSlider .vkuiBaseGallery__bullets {\n  bottom: 0px;\n}\n\n.vkuiBaseGallery {\n  max-width: 90vw;\n  height: 70%;\n}\n\nbutton.without_t:hover,\nbutton.company_btn:hover {\n  cursor: pointer;\n  opacity: 0.9;\n}\n\n.helpModal:hover {\n  cursor: pointer;\n  opacity: 0.6;\n}\n\n.inputTitle {\n  display: flex;\n  align-content: space-around;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.paidGroups {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 54vh;\n}\n\n.quantityPaidGroups {\n  font-size: 48px;\n  font-weight: 900;\n}\n\n.paidGroupsControlView span {\n  font-size: 128px;\n  font-weight: 700;\n  padding: 0px 40px 0px 40px;\n}\n\n.quantityGroups {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.groupsControls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.quantityGroups span {\n  font-size: 128px;\n  font-weight: 700;\n  padding: 0px 40px 40px 40px;\n}\n\n.changeGroupsPaid {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 85vh;\n}\n\n.quantityGroups button,\n.paidGroupsControlView button {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 100%;\n  font-size: 18px;\n}\n\n.groupsAfter {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.gptDriveView {\n  padding: 20px;\n}\n\n.settingsGroups .vkuiGroup {\n  padding: 0 !important;\n}\n\n.save_group {\n  display: none;\n  visibility: hidden;\n}\n\n.vkuiGroup .viewControl {\n  padding: 0 !important;\n  width: 50%;\n}\n\n.viewControl .vkuiDiv {\n  padding: 0 !important;\n}\n\n.viewControl .vkuiSegmentedControl {\n  width: 70%;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Inter\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  height: auto;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n:not(.vkuiModalRoot--desktop).vkuiModalRoot--hasCustomPanelHeaderAfterSlot .vkuiModalRoot__viewport {\n  top: 0px !important;\n}\n\n.vkuiSnackbar {\n  left: 0 !important;\n}\n\n.vkuiModalPage__in {\n  height: 90% !important;\n}\n\n.inputRoot .vkuiModalPage__in-wrap {\n  z-index: 11;\n}\n\n.inputRoot .vkuiModalRoot__mask {\n  z-index: 10;\n}\n\n.inputBody .vkuiModalPage__in-wrap {\n  z-index: 11;\n}\n\n.inputBody .vkuiModalRoot__mask {\n  z-index: 10;\n}\n\n.sign-editor {\n  color: var(--vkui--color_text_primary);\n  padding: 10px;\n  overflow-y: auto;\n  min-height: 8vh;\n  max-height: 60vh;\n  font-size: initial;\n  flex: 1 1;\n  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_placeholder_alpha);\n  border-radius: inherit;\n}\n\n.sign-editor:focus,\n.urlInput:focus {\n  outline: none;\n}\n\n.sign-editor.empty::before {\n  content: attr(data-placeholder);\n  color: #76787a;\n  pointer-events: none;\n}\n\n.signSection .sign-buttons {\n  padding: 10px;\n  gap: 8px;\n}\n\n.urlInput {\n  width: 100%;\n  height: 40px;\n  border-radius: 12px;\n  border: none;\n  padding-left: 8px;\n  font-family: \"Inter\";\n  background: var(--tgui--tertiary_bg_color);\n  box-shadow: 0 0 0 1px var(--tgui--outline);\n  color: var(--tg-theme-text-color);\n}\n\n.format-button.sign-button.button-delete {\n  background-color: #e64646 !important;\n}\n\n.format-button.sign-button.button-delete svg path {\n  fill: #f5f5f5;\n}\n\n.signSection .sign-button {\n  background-color: var(--tgui--tertiary_bg_color) !important;\n  box-shadow: 0 0 0 1px var(--tgui--outline) !important;\n}\n\n.signEditor {\n  padding: 10px;\n  overflow-y: auto;\n  min-height: 8vh;\n  max-height: 60vh;\n  font-size: initial;\n  flex: 1 1;\n  border-radius: inherit;\n}\n\n.signEditor:focus {\n  outline: none;\n}\n\n.signEditor.empty::before {\n  content: attr(data-placeholder);\n  color: #76787a;\n  pointer-events: none;\n}\n\n.img-tag {\n  width: 16px;\n  border-radius: 100%;\n  margin-right: 8px;\n}\n\n.tg_tag {\n  background: #24a1de24 !important;\n}\n\n.vk_tag {\n  background: #0077ff24 !important;\n}\n\n.source-tag {\n  font-size: 13px !important;\n  padding: 0 8px !important;\n}\n\n.sources-input {\n  font-size: 13px !important;\n}\n\n.sign-button {\n  background-color: var(--vkui--color_background--active) !important;\n  color: var(--vkui--color_background_modal_inverse);\n  width: 40px !important;\n  height: auto !important;\n  aspect-ratio: 1 / 1 !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.sign-button.active {\n  background-color: #2688eb !important;\n  border: none;\n  color: #ffffff;\n}\n\n.sign-buttons {\n  display: flex;\n  padding-bottom: 10px;\n  gap: 4px;\n}\n\n.saveButtonWrapper {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  left: 0;\n  right: 0;\n  padding: 10px 20px;\n  box-sizing: border-box;\n  background: var(--vkui--color_background_content);\n}\n\n.inputBody .vkuiFormItem--withPadding,\n.inputRoot .vkuiFormItem--withPadding {\n  background: var(--vkui--color_background_secondary);\n  margin: 10px 0;\n  padding: 10px !important;\n  border-radius: 10px;\n}\n\n.headerSettings .communityButton {\n  flex: 3;\n}\n\n.communityButton .vkuiButton__content {\n  margin: 0 !important;\n  padding: 0 !important;\n  font-size: var(--vkui--font_headline1--font_size--regular) !important;\n}\n\n.communityButton .vkuiButton__in {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-height: 70px;\n}\n\n.communityButton .vkuiButton__before {\n  display: flex;\n  padding: 0 !important;\n}\n\n.modal_choose_full,\n.vkuiModalRoot__mask {\n  z-index: 10;\n}\n\n.modal_choose_full,\n.modal_choose {\n  z-index: 10;\n}\n\n.modal_choose {\n  align-items: flex-start !important;\n  padding-top: 50% !important;\n}\n\n#loginVK {\n  width: 90%;\n  padding-top: 24px;\n}\n\n.onboarding {\n  flex-direction: column;\n  align-items: center;\n  height: 100vh;\n  padding: 0 20px;\n  justify-content: space-evenly;\n}\n\ndiv#Accordion\\:r7\\: {\n  border-radius: 12px !important;\n}\n\n.ModalChannels>div {\n  overflow: auto;\n  scrollbar-width: none;\n}\n\nspan.tgui-c8f4bcd1606fb026.tgui-562f7459d74103ea.tgui-6e63faaa2b33f4ae {\n  background: #2688eb !important;\n}\n\n.addChannel svg {\n  color: #fff !important;\n}\n\nlabel.tgui-b5d680db78c4cc2e.tgui-34eb6f8b96874d40.tgui-b8dfba0b5c3d054c.tgui-7b5bccbb645b495f:hover {\n  opacity: 1 !important;\n}\n\n.copyLink h6,\n.copyLink svg {\n  color: #2688eb !important;\n  font-family: Inter;\n  font-weight: normal;\n}\n\n.sectionChannelRss hr {\n  display: none;\n}\n\n.deleteRss {\n  background: var(--vkui--color_background_negative) !important;\n}\n\n.deleteRss svg {\n  color: #fff !important;\n}\n\n.rssItems {\n  display: flex;\n  flex-direction: column;\n}\n\n.overlaySpinner {\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  background: #000000e3;\n  z-index: 1;\n  left: 0px;\n  top: 0px;\n}\n\n.overlaySpinnerFirst {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  background: #000000e3;\n  z-index: 1;\n  left: 0px;\n  top: 0px;\n}\n\n.overlaySpinner span {\n  font-size: medium;\n}\n\n.onSlide svg {\n  width: 60%;\n}\n\n.onSlide {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n/*.lottie {*/\n/*  padding-bottom: 20px;*/\n/*}*/\n\n.VKID #loginVK {\n  width: 100%;\n}\n\n.VKID {\n  color: #969696;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  height: 70vh;\n  justify-content: space-between;\n}\n\n.VKlogin #loginVK {\n  width: 95%;\n}\n\n.loader-hidden {\n  visibility: hidden;\n}\n\n.loader-visible {\n  visibility: visible;\n}\n\n.post_counter span {\n  font-weight: 700;\n}\n\n.post_counter,\n.post_counter p {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.post_counter p,\n.post_counter span {\n  padding: 0 10px;\n}\n\n.switchAuto {\n  margin: 10px 0;\n}\n\n.premodelist .vkuiSimpleCell {\n  padding: 6px 10px;\n  background: var(--vkui--color_background_secondary);\n  border-radius: 6px;\n}\n\n.switchAuto .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:after {\n  background: #4bb34b;\n}\n\n.switchPremode .vkuiSwitch__self:checked+.vkuiSwitch__pseudo:after {\n  background: #8109b9;\n}\n\n.MuiSvgIcon-root {\n  color: var(--vkui--color_text_primary);\n}\n\n.MuiIconButton-root:hover {\n  background-color: var(--vkui--color_field_background) !important;\n}\n\n.lottie.saveOpt svg {\n  width: 60% !important;\n}\n\n.premodePanel .vkuiPanel__in {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.generatePostButton .vkuiButton__content {\n  font-family: \"Inter\" !important;\n  font-weight: 600 !important;\n  font-size: 14px !important;\n}\n\n.generatePostButton {\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  margin: 30px 12px;\n  padding: 14px 20px 14px 20px;\n  border-radius: 0.7em;\n  background: -webkit-linear-gradient(225deg,\n      rgb(251, 175, 21),\n      rgb(251, 21, 242),\n      rgb(21, 198, 251)) 0% 0% / 300% 300%;\n  background-size: 200% auto;\n  animation: gradient_move 3s ease infinite;\n  border: none;\n  font-family: \"Inter\";\n  transition: all 0.2s ease-in-out;\n  -webkit-transition: all 0.2s ease-in-out;\n}\n\n.gptText {\n  color: var(--vkui--color_text_primary);\n  padding: 10px;\n  font-size: initial;\n  white-space: pre-wrap;\n}\n\n.gptText p {\n  text-align: left;\n  font-size: initial;\n  margin: 0;\n}\n\n.adm-auto-center-content {\n  white-space: pre-wrap;\n}\n\n.inputTitleFirst {\n  display: flex;\n}\n\n.adm-center-popup-wrap {\n  min-width: 90vw !important;\n}\n\n.adm-center-popup-mask {\n  background: rgba(0, 0, 0, 0.8) !important;\n}\n\n.adm-modal-body {\n  font-size: var(--adm-font-size-8);\n  font-family: \"Inter\";\n}\n\n.adm-space.adm-space-block.adm-space-vertical.adm-modal-footer {\n  display: none;\n}\n\n.vkBadge {\n  background-color: var(--vkui--color_icon_accent);\n  color: var(--tg-theme-button-text-color);\n  font-family: \"Inter\";\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  border-radius: 10px;\n  padding: 1px;\n  font-weight: bold;\n  min-width: 56px;\n  margin-left: 10px;\n}\n\n.generatePostButton:hover {\n  transition: all 0.2s ease-in-out;\n  -webkit-transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 1);\n  box-shadow: 0 5px 15px rgba(145, 92, 182, 0.4);\n}\n\n@-webkit-keyframes gradient_move {\n  0% {\n    background-position: 0% 92%;\n  }\n\n  50% {\n    background-position: 100% 9%;\n  }\n\n  100% {\n    background-position: 0% 92%;\n  }\n}\n\n@keyframes gradient_move {\n  0% {\n    background-position: 0% 92%;\n  }\n\n  50% {\n    background-position: 100% 9%;\n  }\n\n  100% {\n    background-position: 0% 92%;\n  }\n}\n\n.premodelist .vkuiVisuallyHidden,\n.post-page .vkuiVisuallyHidden {\n  opacity: 1;\n  width: auto !important;\n  height: auto !important;\n  clip-path: none !important;\n  clip: auto !important;\n  position: inherit !important;\n  padding-top: 20px !important;\n}\n\n.premodelist .vkuiSpinner,\n.post-page .vkuiSpinner {\n  flex-direction: column;\n}\n\n.introFeaturesItem {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 10px;\n  flex: 1;\n}\n\n.premodelist {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.saveOpt div {\n  display: flex;\n  justify-content: center;\n  padding-bottom: 10%;\n  padding-top: 10%;\n}\n\n.PicPopover {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.post_counter {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  background: none;\n  padding: 0 10px;\n}\n\n.VKlogin {\n  color: #969696;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  height: 40vh;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 20% !important;\n}\n\n.welcomeHeadline {\n  font-size: var(--vkui--font_headline2--line_height--compact) !important;\n  padding-bottom: 10px !important;\n  padding-top: 18px !important;\n}\n\n.welcomeDesc {\n  padding-bottom: 30px !important;\n}\n\n.gtpPrompt textarea {\n  height: 100px;\n  font-family: \"Inter\";\n}\n\n.groupInput .react-tagsinput {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  padding-left: 5px;\n  padding-top: 5px;\n  background-color: var(--vkui--color_field_background);\n  border-radius: var(--vkui--size_border_radius--regular);\n  border-color: var(--vkui--color_write_bar_input_border);\n  border-color: var(--vkui--color_field_border_alpha);\n  display: flex;\n  flex-direction: row;\n  width: auto;\n  flex-wrap: wrap;\n}\n\n.groupInput .react-tagsinput-input {\n  color: var(--vkui--color_text_primary);\n  font-family: \"Inter\";\n  font-size: var(--vkui--font_paragraph--font_size--regular);\n  width: 200px;\n}\n\n.groupInput .react-tagsinput--focused {\n  border-color: var(--vkui--color_stroke_accent);\n}\n\n.AppBottom {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: stretch;\n  padding-top: 10px;\n}\n\n.groupInput .react-tagsinput-tag {\n  font-family: \"Inter\";\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 5px;\n  margin-right: 2px;\n  color: var(--vkui--color_text_primary);\n  background: var(--vkui--color_header_background);\n  border: var(--vkui--size_border--regular) solid var(--vkui--color_image_border_alpha);\n  border-radius: 6px;\n  font-size: var(--vkui--font_paragraph--font_size--regular);\n  display: inline-flex;\n  position: relative;\n  align-items: center;\n  padding: 0 12px;\n}\n\n.groupInput .react-tagsinput-remove {\n  cursor: pointer;\n  font-weight: 400;\n  font-size: 26px;\n  color: var(--vkui--color_icon_secondary);\n  padding-left: 4px;\n  padding-bottom: 4px;\n}\n\n.premodelistItem {\n  padding: 0 !important;\n  gap: 6px;\n  display: flex;\n  flex-direction: column;\n}\n\n.vkuiGroup.premodelist {\n  padding: 16px 16px !important;\n}\n\n.quill p {\n  text-align: left;\n  color: var(--tgui--text_color);\n  font-size: var(--tgui--text--font_size);\n}\n\n.applyLink {\n  flex: 1 1;\n  background: #2688eb;\n  border: none;\n  color: var(--tg-theme-button-text-color);\n  margin: 6px 10px;\n  height: 32px;\n  border-radius: 6px;\n  font-family: Inter;\n  transition: all 0.3s;\n}\n\n.applyLink:hover {\n  transition: all 0.3s;\n  opacity: 0.8;\n}\n\n.wrapperUI {\n  padding: var(--tg-content-safe-area-inset-top) 20px 10px 20px !important;\n}\n\n.onboardingUI {\n  height: 90vh;\n}\n\n.vkuiGroup .vkuiFormItem--withPadding {\n  padding: 10px 0 10px 0;\n}\n\n.vkuiSeparator {\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\n\n.userGroups .vkuiBanner__aside {\n  display: none;\n}\n\n.groupItem .vkuiBanner__in,\n.vkuiBanner__in:before {\n  padding: 6px !important;\n  background-color: #ffffff00 !important;\n  border: none !important;\n}\n\n.userGroups .groupItem .vkuiBanner__in,\n.vkuiBanner__in:before {\n  padding: 12px !important;\n  background-color: #ffffff00 !important;\n  border: none !important;\n}\n\n.userGroups .groupItem .vkuiBanner__in {\n  flex-direction: column;\n  align-items: center;\n}\n\n.userGroups .groupItem .vkuiBanner__in .vkuiBanner__before {\n  margin: 0;\n  padding-bottom: 10px;\n}\n\n.userGroups .groupItem .vkuiBanner__in .vkuiBanner__content p {\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 36vw;\n}\n\n.groupsFooter {\n  margin: 0 !important;\n}\n\n.groupItem,\n.groupEdit {\n  padding: 0 !important;\n}\n\n.gmpMode {\n  margin: 0 !important;\n}\n\n.titleItem,\n.channelTitle {\n  padding: 0 !important;\n}\n\n.communityButton {\n  background: var(--vkui--color_background_secondary) !important;\n  color: var(--tg-theme-text-color) !important;\n}\n\n.communityButton:hover {\n  opacity: 0.8;\n}\n\n.postingOn {\n  background: var(--vkui--color_text_positive) !important;\n  color: var(--vkui--color_background_contrast) !important;\n}\n\n.postingOff {\n  background: var(--vkui--color_text_negative) !important;\n  color: var(--vkui--color_background_contrast) !important;\n}\n\n.headerButtonWrapper {\n  display: flex;\n  flex-direction: column;\n  line-height: normal;\n}\n\n.headerButtonTitle {\n  font-size: var(--vkui--font_footnote--font_size--regular);\n  color: var(--vkui--color_background_contrast);\n}\n\n.headerSubButtonTitle {\n  font-size: var(--vkui--font_footnote--font_size--regular);\n  color: var(--tg-theme-text-color);\n  display: flex;\n  align-items: center;\n}\n\n.headerSubButtonTitle span {\n  margin-left: 4px;\n}\n\n.headerButtonDesc {\n  font-size: var(--vkui--font_caption2--font_size--regular);\n  color: var(--vkui--color_background_contrast);\n  font-weight: 400;\n  opacity: 0.8;\n}\n\n.headerSettings {\n  display: flex;\n  padding-top: 12px;\n  box-sizing: border-box;\n}\n\n.headerFirst .communityButton {\n  margin-left: 6px;\n  width: 25% !important;\n}\n\n.headerSettings .communityButton:first-of-type {\n  margin-right: 6px;\n}\n\n.headerSettings .communityButton:last-of-type {\n  margin-left: 6px;\n}\n\n.channelTitle {\n  margin: 0 !important;\n  width: 75% !important;\n}\n\n.channelTitle .vkuiBanner__content p {\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.groupItem p {\n  text-align: left;\n}\n\n.groupImage {\n  border-radius: 100px !important;\n}\n\n/* .vkuiBaseGallery__bullets {\n  position: inherit!important;\n  padding-top: 25px!important;\n} */\n\n.payGroupsFooter {\n  text-align: center;\n}\n\n.payMethod .adm-selector-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  aspect-ratio: 2 / 1;\n  justify-content: center;\n}\n\n.postsSelect .adm-selector-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  border-radius: var(--vkui--size_border_radius--regular);\n  aspect-ratio: 1 / 1;\n  justify-content: center;\n}\n\n.groupsPaid {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 90vh;\n}\n\n.availableSlot {\n  font-size: small;\n  opacity: 50%;\n  padding-left: 10px;\n}\n\n.square,\n.list {\n  color: #f5f5f5;\n}\n\n.square:hover,\n.list:hover {\n  opacity: 80%;\n  cursor: pointer;\n}\n\n.list {\n  opacity: 30%;\n}\n\n.channelsSegmented {\n  width: 30%;\n}\n\n.addChannel {\n  background: #007aff !important;\n}\n\n.addChannel:hover {\n  color: var(--vkui--color_background--hover);\n  background-color: #007bffa4 !important;\n}\n\n.no_data {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 70vh;\n}\n\n.onboardingContainter {\n  display: flex;\n  min-height: 95vh;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.hide-hr hr {\n  display: none;\n}\n\n.OnboardingButtonContainer {\n  width: 100%;\n}\n\n.addSource {\n  background: #2688eb !important;\n  color: #fff !important;\n  max-width: 40px;\n  max-height: 40px;\n}\n\n.addSource:hover {\n  opacity: 0.7;\n}\n\n.addSource svg {\n  color: #fff !important;\n}\n\n.fadeSlide {\n  height: 10px !important;\n}\n\n.welcome_no {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n}\n\n/* .sectionChannelTimersList span {\n  color: var(--vkui--color_text_secondary);\n} */\n\n.sectionChannelTimersList .vkuiButton__content {\n  color: white;\n}\n\n.timerChip h6 {\n  color: var(--vkui--color_text_primary) !important;\n}\n\n.first-name {\n  font-size: 20px;\n}\n\n.postheader {\n  padding-top: 16px;\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  padding: 10px 0 0 0;\n  gap: 10px;\n}\n\n.hideInactiveBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  color: var(--vkui--color_icon_secondary);\n  flex-shrink: 0;\n}\n\n.hideInactiveBtn:hover {\n  background: var(--vkui--color_background_secondary) !important;\n  opacity: 1 !important;\n  color: var(--vkui--color_icon_primary);\n}\n\n.hideInactiveBtn:active {\n  transform: scale(0.92);\n  opacity: 0.85 !important;\n}\n\n.divider {\n  height: 1px;\n  background-color: var(--vkui--color_separator_primary);\n  background-clip: content-box, padding-box;\n}\n\n.HeaderBar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 18px 10px;\n  background: var(--vkui--color_background_secondary);\n  border-radius: var(--vkui--size_border_radius--regular);\n}\n\n.topHeader,\n.bottomHeader {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\nimg.pic {\n  width: 42px;\n  border-radius: 100%;\n}\n\n.PostsCount {\n  background: #007aff;\n  padding: 0 6px 0 6px;\n  border-radius: 100px;\n  color: white;\n}\n\n/*.payform-tinkoff-btn {*/\n/*  display: none;*/\n/*}*/\n\n.paymentTink {\n  display: none;\n}\n\n.payform-tinkoff-btn:hover {\n  cursor: pointer;\n  opacity: 0.9;\n}\n\n.payform-tinkoff-btn:active {\n  cursor: pointer;\n  opacity: 0.8;\n}\n\n.paymentBtn:hover {\n  cursor: pointer;\n  opacity: 0.9;\n}\n\n.paymentBtn:active {\n  cursor: pointer;\n  opacity: 0.8;\n}\n\n.user_info {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding-left: 12px;\n}\n\n.posts_info {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n}\n\n.posts_info .posts_header_text,\n.posts_info .first-name {\n  margin: 0;\n}\n\n.company_info {\n  display: flex;\n  align-items: center;\n}\n\n.user_info p {\n  text-align: start;\n  margin: 0;\n}\n\n.user_info .first-name {\n  font-weight: 500;\n}\n\n.welcome,\n.posts_header_text {\n  font-size: 14px;\n}\n\nheader button {\n  width: 34%;\n  margin: 5%;\n  background-color: var(--tg-theme-secondary-bg-color);\n  border: none;\n  color: var(--tg-theme-text-color);\n  height: 38px;\n  border-radius: 38px;\n  font-family: \"Inter\";\n  font-weight: 500;\n}\n\nheader button:hover,\nimg:hover {\n  background-color: color-mix(in srgb,\n      var(--tg-theme-secondary-bg-color) 90%,\n      transparent);\n  opacity: 90%;\n  cursor: pointer;\n}\n\n/* p {\n  text-align: center;\n  color: var(--tg-theme-text-color);\n  font-size: x-large;\n} */\n\n#content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /*padding-bottom: 6vh;*/\n}\n\n.logo-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.logo-container svg {\n  height: auto;\n  width: 75%;\n  padding-top: 10%;\n  padding-bottom: 10%;\n}\n\n.modal_choose .vkuiCardGrid {\n  width: 100%;\n}\n\n.modal_choose .vkuiBanner__in {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 10px !important;\n  padding-top: 10px !important;\n}\n\n.modal_choose .vkuiBanner__aside {\n  display: none;\n}\n\n.modal_choose .vkuiBanner__before {\n  margin: 10px;\n}\n\n.modeContainer {\n  display: flex !important;\n  padding: 20px 4px;\n  justify-content: space-between;\n}\n\n.modeContainer .adm-space-item {\n  margin: 0 !important;\n}\n\n.modeContainer .adm-radio-content {\n  font-family: var(--vkui--font_text--font_family--regular);\n  font-size: var(--vkui--font_text--font_size--regular);\n}\n\n.userGroups .vkuiCard {\n  margin: 0px !important;\n}\n\n.userGroups .vkuiCardGrid {\n  gap: 8px !important;\n}\n\n.listView .vkuiCardGrid {\n  display: flex !important;\n  flex-direction: column !important;\n  flex-wrap: nowrap !important;\n  gap: 6px !important;\n}\n\n.listView .vkuiCard {\n  display: flex !important;\n  width: 100% !important;\n  margin: 0px !important;\n}\n\n.listView .groupItem {\n  display: flex !important;\n  flex-direction: row !important;\n  width: 100% !important;\n}\n\n.listView .vkuiBanner__in {\n  display: flex !important;\n  width: 100% !important;\n  flex-direction: row !important;\n  flex-wrap: nowrap !important;\n}\n\n.listView .vkuiBanner__before {\n  padding: 0px !important;\n}\n\n.listView .vkuiBanner__content {\n  display: flex !important;\n  align-items: flex-start !important;\n  padding-left: 14px !important;\n}\n\n.listView .vkuiBanner__content p {\n  max-width: 100% !important;\n}\n\n.listView .vkuiBanner__aside {\n  display: flex !important;\n}\n\nspan,\ndiv,\na,\np {\n  font-family: \"Inter\" !important;\n}\n\ndiv[vaul-snap-points-overlay=\"true\"] {\n  background: rgb(0 0 0 / 60%) !important;\n  backdrop-filter: blur(2px);\n}\n\n.channelAddItem {\n  background-color: var(--vkui--color_background_secondary);\n}\n\n.soonItem {\n  opacity: 0.6;\n}\n\n.ModalChannels header h1,\n.ModalChannels footer span {\n  color: var(--vkui--color_text_secondary);\n}\n\n.ModalChannels>div>div>section>div>div {\n  background: none !important;\n}\n\n.adm-picker-view-column:before {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  padding-top: 50px;\n}\n\n.adm-picker-view-column:nth-of-type(1):before {\n  content: \"Часы\";\n}\n\n.adm-picker-view-column:nth-of-type(3):before {\n  content: \"Минуты\";\n}\n\n.adm-picker-view-column:nth-of-type(1) .adm-picker-view-column-item {\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.adm-picker-view-column:nth-of-type(3) .adm-picker-view-column-item {\n  justify-content: flex-start;\n  width: 100%;\n}\n\n#paysuccess .vkuiPanel__in.vkuiInternalPanel__in {\n  display: flex;\n  justify-content: center;\n}\n\n.channelTitleTest {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n.sourceFavicon {\n  background: none !important;\n  box-shadow: none !important;\n}\n\n.fullURL>div {\n  background: color-mix(in srgb,\n      var(--adm-color-primary) 15%,\n      transparent) !important;\n  border-left: 3px solid var(--adm-color-primary) !important;\n  padding: 6px 28px 8px 12px !important;\n  margin: 10px 20px !important;\n}\n\n.fullURL svg {\n  display: none;\n}\n\n.TestDriveCell h6 {\n  color: var(--vkui--color_text_secondary);\n}\n\n.sectionChannel>div>div>div,\n.sectionChannelMode>div>div>label,\n.sectionChannelModeNotice,\n.sectionChannelModeNotice select,\n.sectionChannel label,\n.sectionChannelStreams>div>div>div>label,\n.sectionChannelSources>div>div>div>label,\n.sectionChannelOther div>label {\n  background: var(--vkui--color_background_secondary) !important;\n}\n\n.sectionChannel h1,\n.sectionChannel h6,\n.sectionChannelStyle>footer span,\n.sectionChannelMode h1,\n.sectionChannelMode label>div>span:nth-child(2),\n.sectionChannelStreams h1,\n.sectionChannelSources h1,\n.sectionChannelStreams>div>div>div>div h6,\n.sectionChannelStreams>footer span,\n.sectionChannelSources>div>div>div>div h6,\n.sectionChannelSources>footer span,\n.sectionChannelOther h1,\n.sectionChannelOther h6,\n.sectionChannelTimers h1,\n.sectionChannelStyle h1 {\n  color: var(--vkui--color_text_secondary);\n  white-space: break-spaces;\n}\n\n.sectionChannel svg,\n.settingsItem>div>div>span,\n.sectionChannelStyle svg,\n.settingsItem>div>div>span {\n  color: var(--vkui--color_text_secondary);\n  display: flex;\n  align-items: flex-end;\n}\n\n.sectionChannel>div>div,\n.sectionChannelMode>div>div,\n.sectionChannelOther>div>div,\n.sectionChannelOther>div>div {\n  background: none !important;\n}\n\n.sectionChannelStreams>div>div,\n.sectionChannelSources>div>div,\n.sectionChannelTimers>div>div,\n.sectionChannelTimers select,\n.sectionChannelStyle>div>div {\n  background: var(--vkui--color_background_secondary) !important;\n}\n\n.sectionChannelSources>div>div svg {\n  color: var(--vkui--color_text_secondary);\n}\n\n.sectionChannelStreams>div>div>button svg {\n  color: #2688eb;\n}\n\n.postsItem>div:nth-child(3) span>span {\n  background: #2688eb;\n}\n\n.tgui-1ec4b447aa5cf66a,\n.tgui-8d2d5ba97b4abd79 {\n  color: #2688eb !important;\n}\n\n.tgui-f23c0e195677169c {\n  background: none !important;\n}\n\n.socialBadge {\n  position: absolute;\n  max-width: 16px;\n  bottom: 16px;\n  left: 16px;\n  height: auto;\n  border-radius: 100px;\n  border: 2px solid var(--vkui--color_background_secondary);\n}\n\n@keyframes fade_sources {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.7;\n  }\n}\n\n.sectionPrompts svg {\n  display: none;\n}\n\n.tgui-64a5a0dc5509605e {\n  overflow-wrap: normal !important;\n}\n\n.tgui-97f2df57786b02dc:not(.tgui-ecf101b3117a96c8):after {\n  animation: fade_sources 2s linear infinite !important;\n  background-color: var(--vkui--color_background_modal) !important;\n  border-radius: 6px;\n}\n\n.tgui-97f2df57786b02dc:before {\n  background: var(--vkui--color_background_modal--active) !important;\n  border-radius: 6px;\n}\n\n.SettingsItemIcon {\n  width: 28px;\n  height: 28px;\n}\n\n.tempStyle .tgui-4de4feff2dcc975c,\n.tempStyle .tgui-2b0a006b5a9ffd68 {\n  background: #2688eb !important;\n}\n\n.deleteStream,\n.deleteSource {\n  background: color-mix(in srgb, #ff0000 15%, transparent) !important;\n  color: #ff2929 !important;\n}\n\n.deleteSource h6,\n.deleteSource svg {\n  color: #ff2929 !important;\n}\n\n.addSource {\n  background: #2688eb !important;\n  max-width: 40px;\n  max-height: 40px;\n}\n\n.sectionSourceDone .tgui-8af0d10d5540c6cc:last-of-type {\n  display: none;\n}\n\n.addSource svg {\n  color: #fff !important;\n}\n\n.streamsIcon svg {\n  color: var(--vkui--color_icon_accent_themed);\n}\n\n.adm-swiper-slide {\n  transform: scale(0.95);\n  transition: all 0.3s;\n}\n\n.adm-swiper-slide-active {\n  transform: scale(1) !important;\n}\n\n.adm-page-indicator {\n  --dot-color: var(--adm-color-light);\n  --active-dot-color: var(--adm-color-primary);\n  --dot-size: 8px !important;\n  --active-dot-size: 8px !important;\n  --dot-border-radius: 10px !important;\n  --dot-spacing: 4px !important;\n}\n\n.channelAvatar {\n  box-shadow: none !important;\n}\n\n.postingSwitch input:checked+.tgui-3acc6d0262399734:before {\n  background: #4bb34b !important;\n}\n\n.postingSwitch>div:before {\n  background: #0f0f0f !important;\n}\n\n.timersList {\n  padding: 10px 0 !important;\n}\n\n.timersList>div>div {\n  width: 24vw;\n  background: var(--vkui--color_background--hover);\n}\n\n.onboardingWrapper {\n  display: flex;\n  height: 100vh;\n  justify-content: space-evenly;\n  flex-direction: column;\n}\n\n.onboardingButtonGroups {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.onboardingButtonSet {\n  background: #2990ff !important;\n}\n\n.onboardingButtonSetSecond {\n  background: #2990ff26 !important;\n}\n\n.onboardingButtonLater {\n  color: #2990ff !important;\n}\n\n.sectionOnboardingItems {\n  flex-direction: column;\n  padding: 12px !important;\n  background: var(--vkui--color_background_secondary) !important;\n}\n\n.sectionOnboardingItems>div:nth-child(2) {\n  align-items: center;\n  padding: 0;\n}\n\n.sectionOnboardingItems h6 {\n  color: var(--vkui--color_text_secondary);\n}\n\n.tgui-bca5056bf34297b0 {\n  color: #2688eb !important;\n}\n\n:disabled {\n  cursor: not-allowed;\n  opacity: 0.35;\n}\n\n.tgui-e11a455378c63b15,\n.tgui-b632646f586ff14d {\n  background-color: var(--vkui--color_icon_tertiary--hover) !important;\n}\n\n.saveLoader {\n  color: var(--vkui--color_icon_secondary--hover) !important;\n  position: fixed !important;\n  right: 4vh;\n  bottom: 4vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
